<script setup>
import { useHead } from "@unhead/vue"
import Header from "@/js/partials/Header.vue"
import Hero from "@/js/partials/home/Hero.vue"
import HowTo from "@/js/partials/home/HowTo.vue"
import WhyUs from "@/js/partials/home/WhyUs.vue"
import Stats from "@/js/partials/home/Stats.vue"
import Stories from "@/js/partials/home/Stories.vue"
import Mission from "@/js/partials/home/Mission.vue"
import CTA from "@/js/partials/home/CTA.vue"
import Footer from "@/js/partials/Footer.vue"
useHead({
  script: [
    {
      type: "application/ld+json",
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        url: "https://projetsolaire.com/",
        sameAs: [
          "https://www.facebook.com/projetsolaireofficiel/",
          "https://fr.linkedin.com/company/projetsolaire",
          "https://wellfound.com/company/projetsolaire",
          "https://www.youtube.com/@projetsolaire",
          "https://g.co/kgs/twiRRu7",
        ],
        logo: "https://images.ctfassets.net/1b6f0wuf6ave/42P3RP32nltWjyhI0fg0PY/57029d3dbc531bad21cd75c871078436/logo_official_1.svg",
        name: "projetsolaire",
        description:
          "Bureau d'études photovoltaïque développant la première plateforme d'appel d'offres pour installation de panneaux solaires et les démarches administratives.",
        email: "contact@projetsolaire.com",
        telephone: "+33744098812",
        address: {
          "@type": "PostalAddress",
          streetAddress: "11 Rue Thubaneau",
          addressLocality: "Marseille",
          addressCountry: "FR",
          addressRegion: "Provence-Alpes-Côte d'Azur",
          postalCode: "13001",
        },
        vatID: "FR15878632306",
        iso6523Code: "0009:87863230600014",
      }),
    },
  ],
})
</script>

<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <!-- Site header -->
    <Header />

    <!-- Page content -->
    <main class="grow">
      <!-- Page sections -->
      <Hero />
      <HowTo />
      <Stats />
      <WhyUs />
      <Stories />
      <Mission />
      <CTA />
    </main>

    <!-- Site footer -->
    <Footer />
  </div>
</template>
